import { render, staticRenderFns } from "./AutorizarMovimientoConComentario.vue?vue&type=template&id=257586a0&scoped=true"
import script from "./AutorizarMovimientoConComentario.vue?vue&type=script&lang=js"
export * from "./AutorizarMovimientoConComentario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257586a0",
  null
  
)

export default component.exports